import React, { useMemo, useCallback } from 'react'
import _ from 'lodash'
import { connect } from 'react-redux'
import { toast } from 'react-toastify'

import api, { apiAction, apiActionWithRoute } from '../../../api'

import useModel from '../../../common/useModel'
import required from '../../../common/validators/required'

import {
  TranslatedInput,
  Button,
} from  '../../../components'

import S from './styled'

const OverrideLabelInput = ({
  field, title, defaultLocale, text, model, locales, handleTranslationChange,
}) => (
  <TranslatedInput {...{
    name: `${field}.${defaultLocale}`,
    text,
    title: title,
    defaultValue: title,
    validate: required,
    minWidth: '160px',
    locales,
    defaultLocale,
    translatedField: `${field}`,
    translates: _.get(model, `${field}`),
    onTranslationChange: handleTranslationChange,
  }}/>
)

const LabelLevel = ({ levels, locales, save }) => {

  const initialModel = useMemo(() => ({
    values: levels,
  }), [levels])

  const defaultLocale = locales[0].id

  const { model, text, onChange, values, resetDirty, reset } = useModel(initialModel)

  const handleTranslationChange = useCallback((field, translates) => {
    onChange({
      target: {
        value: translates,
        name: field,
      },
    })
  }, [onChange])

  return (
    <S.Levels>
      <S.Title>{levels.type}</S.Title>
      <S.LevelValues>
        <OverrideLabelInput
          {...{ field: 'values.level0', title: 'Light',
            defaultLocale, locales, text, model, handleTranslationChange,
          }}
        />
        <OverrideLabelInput
          {...{ field: 'values.level1', title: 'Lighter',
            defaultLocale, locales, text, model, handleTranslationChange,
          }}
        />
        <OverrideLabelInput
          {...{ field: 'values.level2', title: 'Medium',
            defaultLocale, locales, text, model, handleTranslationChange,
          }}
        />
        <OverrideLabelInput
          {...{ field: 'values.level3', title: 'Darker',
            defaultLocale, locales, text, model, handleTranslationChange,
          }}
        />
        <OverrideLabelInput
          {...{ field: 'values.level4', title: 'Dark',
            defaultLocale, locales, text, model, handleTranslationChange,
          }}
        />
      </S.LevelValues>
      <S.ItemFooter>
        { !values.new && model.isDirty && (<Button blue outlined onClick={() => reset('values')}>Reset</Button>) }
        <Button
          blue disabled={(!values.new && !model.isDirty) || !model.isValid}
          onClick={() => save(model.values).then(({ type }) => {
            toast.success(`Label levels for '${(type)}' saved `, {
              position: toast.POSITION.TOP_RIGHT,
            })
            resetDirty()
          })}>
          {values.new ? 'Add' : 'Save'}
        </Button>
      </S.ItemFooter>
    </S.Levels>
  )
}

const mapDispatchToProps = (dispatch, { entityName } ) => ({
  save: values =>
    values.new ? dispatch(apiAction(api.addDefaultLabelLevels)(values)) :
      dispatch(apiActionWithRoute(api.updateDefaultLabelLevels)(values.type)(values)),
})

export default connect(null, mapDispatchToProps)(LabelLevel)
